import feather from "feather-icons";
let hasSmallNav = document.body.classList.contains("small-nav");

function fixNavPosition() {
    var innerNav = document.querySelector(".inner-nav");
    if (innerNav) {
        if (window.innerWidth >= 1200) {
            if (document.body.classList.contains("small-nav")) {
                innerNav.style.top = "79px";
            } else {
                innerNav.style.top = "119px";
            }
        } else {
            if (document.body.classList.contains("scrolled")) {
                innerNav.style.top = "39px";
            } else {
                innerNav.style.top = "79px";
            }
        }
    }
}

function dragWithMouse(element) {
    const scrollWrapper = document.querySelector(element);

    if (!scrollWrapper) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    scrollWrapper.style.cursor = 'grab';

    scrollWrapper.addEventListener('mousedown', (e) => {
        isDown = true;
        scrollWrapper.classList.add('dragging');
        startX = e.pageX - scrollWrapper.offsetLeft;
        scrollLeft = scrollWrapper.scrollLeft;
    });
    scrollWrapper.addEventListener('mouseleave', () => {
        isDown = false;
        scrollWrapper.style.cursor = 'grab';
        scrollWrapper.classList.remove('dragging');
    });
    scrollWrapper.addEventListener('mouseup', () => {
        isDown = false;
        scrollWrapper.style.cursor = 'grab';
        scrollWrapper.classList.remove('dragging');
    });
    scrollWrapper.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollWrapper.offsetLeft;
        const walk = (x - startX) * 1; // velocità
        scrollWrapper.scrollLeft = scrollLeft - walk;
    });
}


export function initNavigation() {
    // ------------------------------
    // DESKTOP MENU
    // ------------------------------

    const depth0Links = document.querySelectorAll(
        '.menu-item[data-depth="0"] > li > .has-submenu'
    );
    const depth1Links = document.querySelectorAll(
        '.submenu[data-depth="2"] > li > .has-submenu'
    );

    var backLink = document.querySelector(".js-close-submenu");

    // Fix inner nav top position on load
    fixNavPosition();

    const body = document.body;

    depth0Links.forEach((toggle) => {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const submenu = this.nextElementSibling;
            if (!submenu) return;

            document.body.classList.add("submenu-open");

            var openSubmenus = body.querySelectorAll(
                '.menu-item[data-depth="0"] > li > .submenu.open'
            );

            openSubmenus.forEach(function (openSubmenu) {
                if (openSubmenu !== submenu) {
                    openSubmenu.classList.remove("open");
                    const parentLink = openSubmenu.previousElementSibling;
                    if (parentLink && parentLink.classList.contains("active")) {
                        parentLink.classList.remove("active");
                    }
                }
            });

            this.classList.toggle("active");
            submenu.classList.toggle("open");

            if (!submenu.classList.contains("open")) {
                document.body.classList.remove("submenu-open");
            }
        });
    });

    depth1Links.forEach((toggle) => {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const submenu = this.nextElementSibling;
            if (!submenu) return;

            var openSubmenus = body.querySelectorAll(
                '.submenu[data-depth="2"] > li > .submenu.open'
            );

            openSubmenus.forEach(function (openSubmenu) {
                if (openSubmenu !== submenu) {
                    openSubmenu.classList.remove("open");
                    const parentLink = openSubmenu.previousElementSibling;
                    if (parentLink && parentLink.classList.contains("active")) {
                        parentLink.classList.remove("active");
                    }
                }
            });

            backLink.classList.add("active");
            var oldText = backLink.textContent;
            backLink.textContent = this.getAttribute("data-text") || "Indietro";

            backLink.setAttribute("data-text", oldText);
            this.classList.add("active");
            submenu.classList.add("open");
        });
    });

    backLink.addEventListener("click", function (e) {
        e.preventDefault();

        var openSubmenus = body.querySelectorAll(
            '.submenu[data-depth="2"] > li > .submenu.open'
        );

        if (openSubmenus.length > 0) {
            openSubmenus.forEach(function (openSubmenu) {
                openSubmenu.classList.remove("open");
                const parentLink = openSubmenu.previousElementSibling;
                if (parentLink && parentLink.classList.contains("active")) {
                    parentLink.classList.remove("active");
                }
            });

            var oldText = this.textContent;
            this.textContent = this.getAttribute("data-text") || "Prodotti";
            this.setAttribute("data-text", oldText);
            this.classList.remove("active");
        }
    });

    //   var oldScroll = 0;

    window.addEventListener("scroll", function () {
        var scrollThreshold = parseInt(document.body.dataset.scrollThreshold) || 100;
        var scrollThresholdHomeSmall = parseInt(document.body.dataset.scrollThresholdSmall) || 100;

        var mainSubmenus = document.querySelectorAll(
            '.menu-wrapper .submenu[data-depth="1"]'
        );

        var searchSubmenu = document.querySelector(".menu-wrapper .search-submenu");
        var hasFixedHeader = document.querySelectorAll(".has-fixed-header, .has-fixed-header-image").length > 0;
        var isAgent = document.body.classList.contains("agent");
        var isCart = document.body.classList.contains("cart");
        var isReseller = document.body.classList.contains("reseller");
        var isMobile = window.innerWidth < 992;
        var isHome = document.body.classList.contains("home-page");

        if (!isAgent && !isCart && !isReseller) {
            if (!isHome) {

                if (window.scrollY >= scrollThreshold) {
                    document.body.classList.add("small-nav");
                    mainSubmenus.forEach((mainSubmenu) => {
                        mainSubmenu.style.top = "40px";
                        searchSubmenu.style.top = "40px";
                    });

                    fixNavPosition();
                } else {
                    document.body.classList.remove("small-nav");
                    mainSubmenus.forEach((mainSubmenu) => {
                        mainSubmenu.style.top = "80px";
                        searchSubmenu.style.top = "80px";
                    });

                    fixNavPosition();
                }
            } else {

                if (window.scrollY >= scrollThresholdHomeSmall) {
                    document.body.classList.add("small-nav");
                    mainSubmenus.forEach((mainSubmenu) => {
                        mainSubmenu.style.top = "40px";
                        searchSubmenu.style.top = "40px";
                    });

                    fixNavPosition();
                } else {
                    document.body.classList.remove("small-nav");
                    mainSubmenus.forEach((mainSubmenu) => {
                        mainSubmenu.style.top = "80px";
                        searchSubmenu.style.top = "80px";
                    });

                    fixNavPosition();
                }
            }
        }

        if (window.scrollY > 10) {
            document.body.classList.add("scrolled");
        } else {
            document.body.classList.remove("scrolled");
        }

    }, 100);

    document
        .querySelector(".js-toggle-search")
        .addEventListener("click", function (e) {
            e.preventDefault();

            // Check if submenu is open and close it
            var openSubmenus = body.querySelectorAll(
                '.menu-item[data-depth="0"] > li > .submenu.open'
            );

            openSubmenus.forEach(function (openSubmenu) {
                openSubmenu.classList.remove("open");
                const parentLink = openSubmenu.previousElementSibling;
                if (parentLink && parentLink.classList.contains("active")) {
                    parentLink.classList.remove("active");
                }
            });

            document.body.classList.toggle("search-open");

            setTimeout(() => {
                document.querySelector(".search-submenu input[type='search']").focus();
            }, 300);
        });

    // ------------------------------
    // MOBILE MENU
    // ------------------------------

    // Mobile open/close submenu

    var closeSubmenuBtn = null;
    var mobileMenuToggle = document.querySelector(".js-menu-toggle");
    var mobileMenuActions = document.querySelector(".mobile-menu-actions");
    mobileMenuToggle.addEventListener("click", function () {
        document.body.classList.toggle("mobile-menu-open");

        if (document.body.classList.contains("mobile-menu-open")) {
            this.setAttribute("aria-expanded", "true");
        } else {
            this.setAttribute("aria-expanded", "false");
        }

        // reset mobile menu submenus on close
        if (!document.body.classList.contains("mobile-menu-open")) {
            var openSubmenus = body.querySelectorAll(".mobile-menu .submenu.open");

            openSubmenus.forEach(function (openSubmenu) {
                openSubmenu.classList.remove("open");
                const parentLink = openSubmenu.previousElementSibling;
                if (parentLink && parentLink.classList.contains("active")) {
                    parentLink.classList.remove("active");
                }
            });

            if (closeSubmenuBtn) {
                closeSubmenuBtn.classList.remove("show");
                mobileMenuActions.removeChild(closeSubmenuBtn);
                closeSubmenuBtn = null;
            }

            document.body.classList.remove("search-mobile-open");
        }
    });

    var mobileDepth0Links = document.querySelectorAll(
        '.mobile-menu[data-depth="0"] > li > .has-submenu'
    );
    var mobileDepth1Links = document.querySelectorAll(
        '.mobile-menu .submenu[data-depth="1"] > li > .has-submenu'
    );

    mobileDepth0Links.forEach((toggle) => {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const submenu = this.nextElementSibling;
            if (!submenu) return;

            this.classList.toggle("active");
            submenu.classList.toggle("open");

            if (submenu.classList.contains("open")) {
                closeSubmenuBtn = document.createElement("button");
                closeSubmenuBtn.className = "close-submenu-btn js-close-mobile-submenu";
                closeSubmenuBtn.setAttribute("aria-label", "Close submenu");
                closeSubmenuBtn.setAttribute("role", "button");
                closeSubmenuBtn.setAttribute(
                    "data-submenu-depth",
                    submenu.dataset.depth
                );
                closeSubmenuBtn.innerHTML = '<i data-feather="corner-down-left"></i>';

                if (window.innerHeight <= 700) {
                    mobileMenuActions.style.justifyContent = "space-between";
                } else {
                    mobileMenuActions.style.justifyContent = "center";
                }

                mobileMenuToggle.parentNode.insertBefore(
                    closeSubmenuBtn,
                    mobileMenuToggle
                );

                feather.replace({ "stroke-width": 1 });
                setTimeout(() => {
                    closeSubmenuBtn.classList.add("show");
                }, 50);

                closeSubmenuBtn.addEventListener("click", function (e) {
                    e.preventDefault();

                    var submenuDepth = this.getAttribute("data-submenu-depth");
                    var selector = '[data-depth="' + submenuDepth + '"].open';
                    var openSubmenus = body.querySelectorAll(selector);

                    if (openSubmenus.length > 0) {
                        openSubmenus.forEach(function (openSubmenu) {
                            openSubmenu.classList.remove("open");
                            const parentLink = openSubmenu.previousElementSibling;
                            if (parentLink && parentLink.classList.contains("active")) {
                                parentLink.classList.remove("active");
                            }
                        });

                        if (submenuDepth !== "1") {
                            this.setAttribute("data-submenu-depth", "1");
                        } else {
                            this.classList.remove("show");
                            setTimeout(() => {
                                mobileMenuActions.removeChild(this);
                                mobileMenuActions.style.justifyContent = "center";
                                closeSubmenuBtn = null;
                            }, 300);
                        }
                    }
                });

                mobileMenuActions.style.transform = "translate(-50%, 0)";
            } else {
                closeSubmenuBtn.classList.remove("show");
                mobileMenuActions.removeChild(closeSubmenuBtn);
                mobileMenuActions.style.justifyContent = "center";
                closeSubmenuBtn = null;
            }
        });
    });

    mobileDepth1Links.forEach((toggle) => {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const submenu = this.nextElementSibling;
            if (!submenu) return;

            this.classList.toggle("active");
            submenu.classList.toggle("open");

            if (submenu.classList.contains("open")) {
                // console.log(closeSubmenuBtn);

                closeSubmenuBtn.classList.add("show");
                closeSubmenuBtn.setAttribute(
                    "data-submenu-depth",
                    submenu.dataset.depth
                );
            }
        });
    });

    if (window.innerHeight <= 700) {
        var submenus = document.querySelectorAll(".menu-mobile .submenu");
        submenus.forEach((submenu) => {
            if (submenu.scrollHeight < window.innerHeight) {
                submenu.style.justifyContent = "center";
            } else {
                submenu.style.justifyContent = "flex-start";
            }
        });
    } else {
        var submenus = document.querySelectorAll(".menu-mobile .submenu");
        submenus.forEach((submenu) => {
            submenu.style.justifyContent = "center";
        });
    }

    // translate down mobileMenuActions button on small screens when scroll down and translate up when scroll up
    let lastScrollTop = 0;
    let scrollTimeout;
    let isVisible = true;

    window.addEventListener("scroll", function () {
        if (document.body.classList.contains("mobile-menu-open")) return;

        const st = window.pageYOffset || document.documentElement.scrollTop;

        // Always show toggle if <main></main> height is less than or equal to viewport height
        const mainElement = document.querySelector("main");
        if (mainElement) {
            const mainRect = mainElement.getBoundingClientRect();
            const mainHeight = mainRect.height;
            if (mainHeight <= window.innerHeight) {
                if (!isVisible) {
                    mobileMenuActions.style.opacity = "1";
                    mobileMenuActions.style.transform = "translate(-50%, 0)";
                    isVisible = true;
                }
                lastScrollTop = st;
                return;
            }
        }

        // Calcola l'altezza del footer
        // const footer = document.querySelector('footer');
        // const footerHeight = footer ? footer.offsetHeight : 0;
        // const footerStart = document.documentElement.scrollHeight - footerHeight - window.innerHeight; // punto in cui inizia il footer

        const scrollingDown = st > lastScrollTop;
        // const inFooter = st >= footerStart;

        // Nascondi immediatamente quando scrolli giù o sei nel footer || inFooter
        if ((scrollingDown) && isVisible) {
            mobileMenuActions.style.opacity = "0";
            mobileMenuActions.style.transform = "translate(-50%, 130px)";
            isVisible = false;
        }

        // Clear timeout precedente
        clearTimeout(scrollTimeout);

        // Mostra dopo un breve delay quando scrolli su e non sei nel footer  && !inFooter
        if (!scrollingDown && !isVisible) {
            scrollTimeout = setTimeout(() => {
                mobileMenuActions.style.opacity = "1";
                mobileMenuActions.style.transform = "translate(-50%, 0)";
                isVisible = true;
            }, 50);
        }

        lastScrollTop = Math.max(st, 0);
    });

    var searchMobileToggle = document.querySelector(".js-toggle-search-mobile");
    searchMobileToggle.addEventListener("click", function (e) {
        e.preventDefault();
        if (!document.body.classList.contains("mobile-menu-open")) return;

        document.body.classList.toggle("search-mobile-open");

        if (document.body.classList.contains("search-mobile-open")) {
            setTimeout(() => {
                document
                    .querySelector(".search-mobile-submenu input[type='search']")
                    .focus();
            }, 300);
        } else {
            document
                .querySelector(".search-mobile-submenu input[type='search']")
                .blur();
        }
    });

    window.addEventListener("resize", function () {

        if (window.innerHeight <= 700) {
            var submenus = document.querySelectorAll(".menu-mobile .submenu");
            submenus.forEach((submenu) => {
                if (submenu.scrollHeight < window.innerHeight) {
                    submenu.style.justifyContent = "center";
                } else {
                    submenu.style.justifyContent = "flex-start";
                }
            });
        } else {
            var submenus = document.querySelectorAll(".menu-mobile .submenu");
            submenus.forEach((submenu) => {
                submenu.style.justifyContent = "center";
            });
        }

    });

    var footerSubmenuToggles = document.querySelectorAll(".js-footer-open-submenu");
    footerSubmenuToggles.forEach((toggle) => {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const submenuName = this.dataset.submenu;
            if (!submenuName) return;

            if (window.innerWidth < 1200) {
                document.getElementById(submenuName + '-mobile').click();
                setTimeout(() => {

                    // Open mobile menu if not already open
                    document.body.classList.add("mobile-menu-open");

                    // Show close button
                    var mobileMenuActions = document.querySelector(".mobile-menu-actions");
                    mobileMenuActions.style.opacity = "1";
                    mobileMenuActions.style.transform = "translate(-50%, 0)";
                }, 300);
            } else {
                // console.log(document.getElementById(submenuName));

                document.getElementById(submenuName).click();
            }

        });
    });

    // External click close submenu
    document.addEventListener("click", function (e) {
        var isFooterLink = e.target.closest(".js-footer-open-submenu");
        if (isFooterLink) return;
        var isClickInsideMenu = e.target.closest(".menu-wrapper");
        var isClickOnToggle = e.target.closest(".has-submenu");
        var isTopNav = e.target.closest(".top-nav");

        if (!isClickInsideMenu && !isClickOnToggle && !isTopNav) {
            var openSubmenus = body.querySelectorAll(
                '.menu-item[data-depth="0"] > li > .submenu.open'
            );

            openSubmenus.forEach(function (openSubmenu) {
                openSubmenu.classList.remove("open");
                const parentLink = openSubmenu.previousElementSibling;
                if (parentLink && parentLink.classList.contains("active")) {
                    parentLink.classList.remove("active");
                }
            });

            document.body.classList.remove("submenu-open");
        }
    });


    dragWithMouse('.scroll-wrapper');
    dragWithMouse('.scrollbar-wrapper');

}
